import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'protocolCheck',
    pure: false,
    standalone: true
})

@Injectable()

export class ProtocolCheckPipe implements PipeTransform {

  constructor () {}

  transform(url: any): any {

    if(!url)
      return;

    const regExpData = /^data:/;
    const regExp = /^https:/;

    if (!regExp.test(url) && !regExpData.test(url)) {
        url = "https:" + url;
    }

    return url;
  }
}
